<template>
  <tr>
    <td>{{ presentation.id }}</td>
    <td>{{ presentation.name }}</td>
    <td>{{ presentation.accessCode }}</td>
    <td>{{ presentation.uniqueAccessCode }}</td>
    <td><Formatter type="date" :value="presentation.createdAt" /></td>
    <td><Formatter type="date" :value="presentation.modifiedAt" /></td>
    <td><Formatter type="date" :value="presentation.updatedAt" /></td>
    <td class="text-center">
      <span
        v-if="isPresentationDeletedMoreThanAMonth"
        class="text-success pointer mr-2"
        @click="handleRecoverButtonClick()"
      >
        <i v-if="isPresentationRecovering" class="fa fa-spinner fa-spin"></i>
        <i v-else class="fas fa-undo" />
      </span>
      <span
        class="text-danger pointer"
        title="Unlink presentation from user"
        @click="handleUnlinkButtonClick()"
      >
        <i v-if="isPresentationUnlinking" class="fa fa-spinner fa-spin"></i>
        <i v-else class="fas fa-unlink" />
      </span>
    </td>
  </tr>
</template>

<script>
import { mapActions } from 'vuex'
import moment from 'moment'

import configs from '../../config'

// UI
import Formatter from '../UI/Fomatter.vue'

export default {
  components: {
    Formatter,
  },
  data() {
    return {
      isPresentationRecovering: false,
      isPresentationUnlinking: false,
    }
  },
  computed: {
    isPresentationDeletedMoreThanAMonth() {
      const now = moment()
      const deletedTimestamp = moment(this.presentation.updatedAt)

      return now.diff(deletedTimestamp, 'months') < 1
    },
  },
  props: {
    presentation: {
      type: Object,
      required: true,
    },
    handleRecoverPresentation: {
      type: Function,
      required: true,
    },
    user: {
      type: Object,
      required: true,
      default: () => {},
    },
  },
  methods: {
    ...mapActions('presentations', ['unlinkPresentations']),
    async handleRecoverButtonClick() {
      const { id: presentationId, name } = this.presentation
      const areYouSure = confirm('Are you sure that you want to recover this presentation?')

      if (!areYouSure || this.isPresentationRecovering) return

      try {
        this.isPresentationRecovering = true
        await this.$http.post(configs.api.recoverPresentation, {
          presentationId,
        })
        this.handleRecoverPresentation(presentationId)
        this.$toasted.success(`Recover presentation ${name} successfully`)
      } catch {
        this.$toasted.error(`Recover presentation ${name} failed`)
      } finally {
        this.isPresentationRecovering = false
      }
    },
    async handleUnlinkButtonClick() {
      const { id: presentationId, name } = this.presentation
      const areYouSure = confirm(`Are you sure that you want to unlink presentation "${name}" from user ${this.user.email}?`)

      if (!areYouSure || this.isPresentationUnlinking) return

      try {
        this.isPresentationUnlinking = true
        await this.unlinkPresentations({
          presentationIds: [presentationId],
          email: this.user.email,
          userId: this.user.id,
          options: {}
        })
        this.$toasted.success(`Unlinked presentation "${name}" from user successfully`)
        // Optionally refresh the presentation list or remove from current view
        this.$emit('presentation-unlinked', presentationId)
      } catch (error) {
        console.error('Error unlinking presentation:', error)
        this.$toasted.error(`Failed to unlink presentation "${name}"`)
      } finally {
        this.isPresentationUnlinking = false
      }
    },
  },
}
</script>